

import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppTranslateModule} from '../translate/translate.module';
import {NotificationBarComponent} from './notifier';
import {NotificationBarService} from './notification.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


@NgModule({
    imports: [
      CommonModule,
      AppTranslateModule,
      BrowserAnimationsModule
    ],
    exports: [
      NotificationBarComponent
    ],
    declarations: [NotificationBarComponent],
    providers: [NotificationBarService],
})
export class NotifyModule {
  constructor(@Optional() @SkipSelf() parentModule: NotifyModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/notify/notifier.module.ts